import { TabType } from "@hooks/useTabs";
import AssessmentSection from "@sia/components/HowToNominate/AssesmentSection";
import DeclarationsSection from "@sia/components/HowToNominate/DeclarationSection";
import NominationsSection from "@sia/components/HowToNominate/NominationsSection";

/**
 * Returns the corresponding static component to render based on the provided active tab identifier.
 *
 * This function is typically used to dynamically render different sections of the
 * Design AI and Tech Awards (DTA) How to Nominate page.
 *
 * @param page - The string identifier of the active tab (e.g., "submissions", "assessment").
 * @returns The React component corresponding to the given page, or `undefined` if not matched.
 */
export const HowToNominateTabsFactory = (tab: TabType) => {
  switch (tab) {
    case "nominationsTab":
      return NominationsSection;

    case "assessmentTab":
      return AssessmentSection;

    case "declarationsTab":
      return DeclarationsSection;
  }
};
